export default {
  getDeclaracaoImportacaoTableHeaders(state) {
    return state.declaracaoImportacaoTableHeaders;
  },
  getDeclaracaoImportacaoTableItems(state) {
    return state.declaracaoImportacaoTableItems;
  },
  getItemsDeclaracaoImportacaoByCodigoDI(state) {
    return state.itemsDeclaracaoImportacaoByCodigoDI;
  },
  getTableHeadersItemsDeclaracaoImportacaoByCodigoDI(state) {
    return state.declaracaoImportacaoTableHeaders
      .filter((header) => ['NCM', 'pesoLiquido', 'quantidade', 'valor', 'produto', 'moeda'].includes(header.value));
  },
  getFiltros(state) {
    return state.filtros;
  },
};
